import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, change } from 'redux-form';

//Material Components
import Grid from '@material-ui/core/Grid';

// Engage Actions 
import { UpdateCommunyV2 } from '../../actions/communityActions';

//Engage Components
import {
    renderLegacyTextField,
    LrenderSwitch
} from '../../utils/engageComponents';

export class ManagementCommunity extends Component {

    constructor(props) {
        super(props);

        this.state = {
            community: props.communityInfo,
            name: props.name,
            isVoiceAvailable: false,
            logsRecipient: props.communityInfo ? props.communityInfo.logsRecipient : ''
        };

    }

    componentWillReceiveProps(nextProps) {
        let communityId = this.state.community ? this.state.community._id : undefined
        if (communityId === undefined || communityId !== nextProps.communityInfo._id) {
            this.setState(
                {
                    community: nextProps.communityInfo,
                    name: nextProps.name,
                    isVoiceAvailable: nextProps.communityInfo.isVoiceAvailable,
                    logsRecipient: nextProps.communityInfo.logsRecipient
                }
            );

            if (nextProps.communityInfo) {
                this.props.dispatch(change('ManagementCommunity', '_id', nextProps.communityInfo._id));
                this.props.dispatch(change('ManagementCommunity', 'name', nextProps.name));
                this.props.dispatch(change('ManagementCommunity', 'logsRecipient', nextProps.communityInfo.logsRecipient));
                this.props.dispatch(change('ManagementCommunity', 'isVoiceAvailable', nextProps.communityInfo.isVoiceAvailable));
            } else {
                this.props.dispatch(change('ManagementCommunity', '_id', ''));
                this.props.dispatch(change('ManagementCommunity', 'name', ''));
                this.props.dispatch(change('ManagementCommunity', 'logsRecipient', ''));
                this.props.dispatch(change('ManagementCommunity', 'isVoiceAvailable', false));
            }
        } else if (communityId === nextProps.communityInfo._id) {
            this.props.dispatch(change('ManagementCommunity', 'logsRecipient', this.state.logsRecipient));
            this.props.dispatch(change('ManagementCommunity', 'isVoiceAvailable', this.state.isVoiceAvailable));
        }

    }

    async onSubmitHandler(formData) {
        if (formData._id) {
            const stylesObj = { modalStyles: { backgroundColor: '#ffffff' }, messageClass: 'LAlertMessageStyles' };
            await this.props.UpdateCommunyV2(formData._id, {
                isVoiceAvailable: this.state.isVoiceAvailable,
                logsRecipient: formData.logsRecipient
            }, stylesObj);
        }
    };

    render() {
        const communityInfo = this.state.community;

        return (
            <>
                <div id="save_btn" className="appbtn-engage skybluebtn-engage" style={{ display: 'none' }} onClick={this.props.handleSubmit(this.onSubmitHandler.bind(this))}>
                    Save
                </div>
                <Grid container justify='space-around'  >
                    <Grid item xs={12} sm={12} md={2} lg={2} style={{ padding: '0px 10px' }} >
                        <Grid container direction='column'>
                            <Grid item xs={12} >
                                <Grid container direction='colum'>
                                    <Grid item xs={12} style={{ padding: '10px', marginTop: '30px' }}>
                                        <Grid item container xs={12} justify='center'>
                                            <Grid style={{ borderBottom: '1px solid white', cursor: 'pointer' }}>
                                                {communityInfo ?
                                                    <img
                                                        src={communityInfo.logo}
                                                        alt=''
                                                        height={'300px'}
                                                        width={'300px'}
                                                        style={{ objectFit: "scale-down" }}
                                                    />
                                                    : ""
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} className='LCommunityName'>
                                        {
                                            communityInfo ? communityInfo.address : ""
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={9} lg={9} className='LborderLine' style={{ padding: '0px 20px' }}>
                        <Grid container direction='column'>
                            <Grid item xs={7}>
                                <Grid container direction='colum'>
                                    <Grid item xs={12} style={{ padding: '10px' }}>
                                        <Field
                                            name="name"
                                            label="Community Name"
                                            className='LTextField'
                                            isReadOnly={true}
                                            maxLength={20}
                                            onChange={(e, newItem) => this.setState({ name: newItem })}
                                            component={renderLegacyTextField}
                                            id='Legacy_Community_Name'
                                        />
                                    </Grid>

                                    <Grid item xs={12} style={{ padding: '10px' }}>
                                        <Field
                                            name="logsRecipient"
                                            label="System Logs Email"
                                            className='LTextField'
                                            maxLength={45}
                                            onChange={(e, newItem) => this.setState({ logsRecipient: newItem })}
                                            component={renderLegacyTextField}
                                            id='Legacy_Community_Logs'
                                        />
                                    </Grid>

                                    <Grid id='setup_general_voice_settings' item xs={12} style={{ padding: '10px' }}>
                                        <Grid container direction='column'>
                                            <Grid item xs={12} >
                                                <Grid container className='LsetUpGridColum' direction='colum'>
                                                    <Grid item container xs={12}>
                                                        <Grid item container>
                                                            <Grid item xs={2} sm={2} md={2} >
                                                                <Field
                                                                    idToSet='setup_general_voiceId_switch'
                                                                    name="isVoiceAvailable"
                                                                    onClick={() => {
                                                                        this.setState((prevState) => (
                                                                            { isVoiceAvailable: !prevState.isVoiceAvailable }))
                                                                    }}
                                                                    checked={this.state.isVoiceAvailable}
                                                                    component={LrenderSwitch}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={10} sm={10} md={10} className="LVoiceTitle">
                                                                Enable voice for entire community
                                                            </Grid>
                                                            <Grid item xs={2} sm={2} md={2} >
                                                            </Grid>
                                                            <Grid item xs={10} sm={10} md={10}>
                                                                {this.state.isVoiceAvailable ?
                                                                    <Grid item xs={12} sm={12} md={12} className="LVoiceSubTitle">
                                                                        <h4>Turning this off will disable voice commands for all eHubs.</h4>
                                                                        <h4>It will also remove the TV remote’s FAV1 and FAV2 button customization.</h4>
                                                                    </Grid>
                                                                    :
                                                                    <Grid item xs={12} sm={12} md={12} className="LVoiceSubTitle">
                                                                        <h4>Turning this on will enable all eHubs to use voice commands.</h4>
                                                                        <h4>It will also enable the TV remote’s FAV1 and FAV2 button customization.</h4>
                                                                    </Grid>
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </>
        )
    }
}

function mapStateToProps(state) {

    return {}
}


export default connect(mapStateToProps, { UpdateCommunyV2 })(reduxForm({
    form: 'ManagementCommunity',
    enableReinitialize: true
})(ManagementCommunity));